// extracted by mini-css-extract-plugin
export var clickableWrapper = "_3d-2";
export var placeholderIcon = "_3d-3";
export var thumbnailCanvas = "_3d-1";
export var thumbnailWrapper = "_3d-0";